import { render, staticRenderFns } from "./LearningGroupList.vue?vue&type=template&id=6ab6868d&"
import script from "./LearningGroupList.vue?vue&type=script&lang=ts&"
export * from "./LearningGroupList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports